import { InfoLayout } from "../../components/InfoLayout";

/**
 * Deliberately links to no source repository.
 *
 * This page used to say PyDialog was "developed in the open" and sent people
 * to GitHub to browse the code and open issues. The repository is private, so
 * those were three dead links — and, worse, a public statement that the work
 * was free to take, sitting next to an all-rights-reserved footer.
 */

/**
 * Where learners and schools should write. Null until an address exists:
 * rendering a mailto: nobody reads is the same broken promise as the GitHub
 * links this page used to carry. Set it and the card below appears.
 */
const CONTACT_EMAIL: string | null = null;

export function ContactPage() {
  return (
    <InfoLayout
      title="Contact"
      lead="Questions, feedback, or something not working? Here's how to reach us."
    >
      <div className="card">
        <h3>Your school comes first</h3>
        <p>
          If you study through a school or a teacher who runs PyDialog, your
          instructor or administrator is the fastest route for anything about
          your account, your subjects or your results. They can reset a lesson,
          correct your details, and see your progress.
        </p>
      </div>

      <div className="card">
        <h3>Something wrong in a lesson?</h3>
        <p>
          A wrong answer marked correct, a figure that doesn't render, or a
          question that doesn't make sense — tell your instructor with the
          subject, the lesson name and what you saw. Those three things are
          what make it findable.
        </p>
      </div>

      {CONTACT_EMAIL && (
        <div className="card">
          <h3>Everything else</h3>
          <p>
            For anything your school can't answer — including a request for a
            copy or deletion of your data — write to{" "}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
        </div>
      )}

      <div className="card">
        <h3>About the software</h3>
        <p>
          PyDialog is proprietary software. The source is not published, and no
          permission is given to copy or reuse it or its curriculum content.
          Licensing enquiries are welcome through the channels above.
        </p>
      </div>
    </InfoLayout>
  );
}
